/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Classifications_TitleInputs */

const vi_trace_classifications_title = /** @type {(inputs: Trace_Classifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại sản phẩm`)
};

/**

* @param {Trace_Classifications_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_classifications_title = /** @type {((inputs?: Trace_Classifications_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Classifications_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_classifications_title(inputs)
});